/**
 * AirtableLogo/index.js
 * desc: Airtable product logo
 * note: renders an accessible button (aria-label) when given an onClick handler; otherwise a static figure
 */
'use strict';

import IconButton from '../IconButton';


const AirtableLogo = (props) => (
    <IconButton baseClassName="airtable logo" label="Airtable" tooltip={ null } { ...props }>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M28.578 5.906L4.717 15.78c-1.327.55-1.313 2.434.022 2.963l23.96 9.502a8.89 8.89 0 0 0 6.555 0l23.96-9.502c1.335-.53 1.35-2.414.022-2.963l-23.86-9.873a8.89 8.89 0 0 0-6.799 0" fill="#fc0"/><path d="M34.103 33.433V57.17a1.6 1.6 0 0 0 2.188 1.486l26.7-10.364A1.6 1.6 0 0 0 64 46.806V23.07a1.6 1.6 0 0 0-2.188-1.486l-26.7 10.364a1.6 1.6 0 0 0-1.009 1.486" fill="#31c2f2"/><path d="M27.87 34.658l-8.728 4.215-16.727 8.015c-1.06.512-2.414-.26-2.414-1.44V23.17c0-.426.218-.794.512-1.07a1.82 1.82 0 0 1 .405-.304c.4-.24.97-.304 1.455-.112l25.365 10.05c1.3.512 1.4 2.318.133 2.925" fill="#ed3049"/><path d="M27.87 34.658l-7.924 3.826L.512 22.098a1.82 1.82 0 0 1 .405-.304c.4-.24.97-.304 1.455-.112l25.365 10.05c1.3.512 1.4 2.318.133 2.925" fill="#c62842"/></svg>
    </IconButton>
);


export default AirtableLogo;
